// 註冊頁面翻譯
export default {
  title: "用戶註冊",
  subtitle: "創建您的新賬號",
  switchToLogin: "已有賬戶？登錄",

  // 表單字段標籤和佔位符
  account: "賬號",
  accountPlaceholder: "請輸入賬號",
  phone: "手機號",
  phonePlaceholder: "請輸入手機號",
  captcha: "驗證碼",
  captchaPlaceholder: "請輸入簡訊驗證碼",
  password: "密碼",
  passwordPlaceholder: "8-16位，至少包含字母、數字、特殊字符組合",
  confirmPassword: "確認密碼",
  confirmPasswordPlaceholder: "請再次確認密碼",

  // 按鈕文本
  register: "註冊",
  getCaptcha: "獲取驗證碼",
  closeDialog: "關閉彈窗",
  backToLogin: "返回登錄",

  // 成功提示
  registerSuccess: "註冊成功",
  registerSuccessSubtitle: "添加企業微信申請更多服務！",

  // 錯誤消息
  registerFailed: "註冊失敗請重試",
  getCaptchaFirst: "請先獲取驗證碼或驗證碼已過期！",

  // 表單驗證消息
  validation: {
    accountRequired: "請輸入賬號",
    accountLength: "長度在 2 到 20 個字符",
    phoneRequired: "請輸入手機號碼",
    phoneFormat: "請輸入正確的手機號",
    captchaRequired: "請輸入驗證碼",
    captchaFormat: "驗證碼格式不對",
    passwordRequired:
      "非中文字符8-16位，至少1個字母、1個數字和1個特殊字符的組合",
    passwordLength: "非中文字符8-16位，至少1個字母、1個數字和1個特殊字符的組合",
    passwordPattern:
      "非中文字符8-16位，至少1個字母、1個數字和1個特殊字符的組合",
    passwordAscii: "請輸入8-16位的非中文字符",
    passwordLetter: "請至少輸入1個字母",
    passwordNumber: "請至少輸入1個數字",
    passwordSpecial: "請至少輸入1個非中文特殊字符",
    confirmPasswordRequired: "請再次輸入密碼",
    passwordMismatch: "兩次輸入的密碼不一致，請重新輸入",
  },
};
